export const CookiesSection1 = () => {
  return (
    <>
      <section id="introduction">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Introduction</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>
            This Cookies Policy explains how WinGrow (&quot;we,&quot; &quot;our,&quot; or
            &quot;us&quot;) uses cookies and similar tracking technologies when you use our lead
            management platform and website at wingrow.io (the &quot;Service&quot;).
          </p>
          <p>
            By using our Service, you consent to the use of cookies in accordance with this policy.
            If you do not agree to our use of cookies, you should set your browser settings
            accordingly or refrain from using our Service.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">What Are Cookies?</h3>
          <p>
            Cookies are small text files that are placed on your device (computer, smartphone,
            tablet) when you visit a website. They are widely used to make websites work more
            efficiently, provide a better user experience, and provide information to website
            owners.
          </p>
          <p>Cookies can be:</p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>
              <strong>Session cookies:</strong> Temporary cookies that expire when you close your
              browser
            </li>
            <li>
              <strong>Persistent cookies:</strong> Cookies that remain on your device for a set
              period or until you delete them
            </li>
            <li>
              <strong>First-party cookies:</strong> Set by the website you&apos;re visiting
              (WinGrow)
            </li>
            <li>
              <strong>Third-party cookies:</strong> Set by external services (e.g., analytics,
              advertising)
            </li>
          </ul>
        </div>
      </section>

      <section id="cookie-types">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Types of Cookies We Use</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>We use the following categories of cookies on our Service:</p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">2.1 Essential Cookies</h3>
          <p>
            These cookies are necessary for the Service to function properly and cannot be disabled.
            They enable core functionality such as:
          </p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>User authentication and session management</li>
            <li>Security and fraud prevention</li>
            <li>Remembering your preferences and settings</li>
            <li>Enabling navigation and access to secure areas</li>
          </ul>
          <p className="text-sm italic text-gray-600">
            Without these cookies, the Service cannot function properly.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            2.2 Analytics and Performance Cookies
          </h3>
          <p>
            These cookies help us understand how visitors use our Service by collecting information
            about:
          </p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Number of visitors and page views</li>
            <li>How visitors navigate through the site</li>
            <li>Which features are most popular</li>
            <li>Performance issues or errors</li>
          </ul>
          <p>We use the following analytics services:</p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>
              <strong>Google Analytics:</strong> Tracks website usage and user behavior (uses
              cookies like _ga, _gid, _gat)
            </li>
          </ul>
          <p className="text-sm italic text-gray-600">
            All information collected is aggregated and anonymous. We use this data to improve our
            Service.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">2.3 Functional Cookies</h3>
          <p>These cookies enable enhanced functionality and personalization, such as:</p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Remembering your language and region preferences</li>
            <li>Saving your dashboard customizations</li>
            <li>Personalizing content based on your usage</li>
            <li>Remembering previously entered form data</li>
          </ul>
          <p className="text-sm italic text-gray-600">
            Disabling these cookies may limit some features of the Service.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            2.4 Advertising and Marketing Cookies (If Used)
          </h3>
          <p>
            These cookies may be used to deliver relevant advertisements and track advertising
            campaign performance. They may include:
          </p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Facebook Pixel (if implemented)</li>
            <li>Conversion tracking pixels</li>
            <li>Retargeting cookies</li>
          </ul>
          <p className="text-sm italic text-gray-600">
            We will only use advertising cookies with your consent where required by law.
          </p>
        </div>
      </section>
    </>
  );
};
